import type { QuestionRatingModelData } from '@coorum-research/shared-common/types/survey-json.type'
import { RatingStarIcon } from '../icons/RatingStarIcon'

type Answer = {
  text?: string
  link?: string
}

type Props = {
  questionElement: QuestionRatingModelData
  answer: Answer | Answer[]
  themeColor: string
}

export function RatingAnswer({ questionElement, answer, themeColor }: Props) {
  // 回答値を数値に変換
  const ratingValue = Array.isArray(answer)
    ? Number(answer[0]?.text) || 0
    : Number(answer.text) || 0

  // レーティング設定値
  const rateMax = questionElement.rateMax ?? questionElement.rateCount ?? 5
  const rateMin = questionElement.rateMin ?? 1
  const rateType = questionElement.rateType ?? 'stars'

  // 星表示のみ許可 (ref: apps/admin-client/src/composables/use-survey-creator.ts)
  if (rateType === 'stars') {
    const stars = []
    for (let i = rateMin; i <= rateMax; i++) {
      const isFilled = i <= ratingValue
      stars.push(
        <RatingStarIcon
          key={i}
          filled={isFilled}
          color={themeColor}
          width={16}
          height={16}
        />,
      )
    }
    return <div className="flex items-center gap-0.5">{stars}</div>
  }
}
